<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jnRHq/tc-custom/9780802196163.jpg?1705779176369" alt="This image is the cover for the book Immaculate Invasion"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Immaculate Invasion
      </h1>
      <p class="bookDescription body article font2">
        <b>“Every war brings forth one perfect book. . . . Now we have <i>The Immaculate Invasion</i>, the masterpiece of the 1994 US assault on and occupation of Haiti.” —<i>Chicago Tribune</i></b><br/>  <br/> Widely celebrated upon its original publication in 1999, National Book Award winning writer Bob Shacochis’s <i>The Immaculate Invasion</i> is a gritty, poetic, and revelatory look at the American intervention in Haiti.<br/>  <br/> In 1994, the United States embarked on Operation Uphold Democracy, a response to the overthrow of the democratically elected Haitian government by a brutal military coup. As a reporter for <i>Harper’s</i>, Bob Shacochis traveled to Haiti and was embedded—long before the idea became popular in Iraq—with a team of Special Forces commandos for eighteen months. He came away with tremendous insight into Haiti, the character of American fighters, and what can happen when an intervention turns into a misadventure.<br/>  <br/> In <i>The Immaculate Invasion</i>, Shacochis captures the exploits and frustrations, the inner lives and heroic deeds of young Americans as they struggle to bring democracy to a country ravaged by tyranny. <i>The Immaculate Invasion</i> is required reading for anyone who wants to understand what has happened in Haiti in the past, its current state, and its future path.<br/>  <br/> “An extraordinary book about an extraordinary event . . . I felt transported to Haiti. I could hear it. I could smell it. At moments I felt moved almost to tears, only to find myself, a page or two later, laughing out loud.” —Tracy Kidder, Pulitzer Prize–winning author of <i>The Soul of a New Machine</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bob Shacochis
      </h2>
      
      <p class="authorDescription body article">Bob Shacochis is the author of Easy in the Islands, winner of the 1985 National Book Award for first fiction; The Next New World, which was awarded the Prix de Rome and the American Academy of Arts and Letters; and Swimming in the Volcano, a National Book Award finalist. He is currently a contributing editor for Outside and Harper's magazines.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Groove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f10cff1